
import {
    Box,
    Link,
    Grid,
    Table,
    Thead,
    Tbody,
    Tfoot,
    Tr,
    Th,
    Td,
    TableCaption,
    Button,
    Stack,
    Menu,
    MenuItem,
    MenuList,
    Badge,
    MenuButton
} from "@chakra-ui/react";
import { NavLink } from 'react-router-dom';
import Card from "components/card/Card"
import moment from 'moment'; // Import moment for date/time formatting

import React, { useState, useEffect, } from 'react';
import { MdArrowDropDown, MdForkRight } from "react-icons/md";

export default function Overview() {
    const [companies, setCompanies] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [companiesPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const userId = sessionStorage.getItem('userId');

        if (!userId) {
            window.location.href = '/login';
        }

        const fetchCompanies = async () => {
            try {
                const response = await fetch(`https://api.cloudace.co.uk/get-atds?userId=${userId}`);
                if (response.ok) {
                    const data = await response.json();
                    setCompanies(data);
                } else {
                    console.error('Failed to fetch company data');
                }
            } catch (error) {
                console.error('Error fetching company data:', error);
            }
        };

        fetchCompanies();
    }, []);

    const handleStatusChange = async (id, newStatus) => {
        try {
            const response = await fetch(`https://api.cloudace.co.uk/update-status/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ aStatus: newStatus })
            });

            if (response.ok) {
                const updatedCompanies = companies.map(company =>
                    company.id === id ? { ...company, aStatus: newStatus } : company
                );
                setCompanies(updatedCompanies);
            } else {
                console.error('Failed to update status');
            }
        } catch (error) {
            console.error('Error updating status:', error);
        }
    };

    const handleDelete = async (id) => {
        try {
            const response = await fetch(`https://api.cloudace.co.uk/delete-attendance/${id}`, {
                method: 'DELETE'
            });

            if (response.ok) {
                // Remove the deleted attendance from the state
                setCompanies(companies.filter(company => company.id !== id));
            } else {
                console.error('Failed to delete attendance record');
            }
        } catch (error) {
            console.error('Error deleting attendance record:', error);
        }
    };

    const indexOfLastCompany = currentPage * companiesPerPage;
    const indexOfFirstCompany = indexOfLastCompany - companiesPerPage;
    const currentCompanies = companies
        .filter(company =>
            company &&
            company.eFname &&
            company.eLname &&
            company.lName &&
            company.aDate &&
            company.aInTime &&
            company.aOutTime &&
            company.aInTimeRemark &&
            company.aDefaultBreak
        )
        .filter(company =>
            company.eFname.toLowerCase().includes(searchTerm.toLowerCase()) ||
            company.eLname.toLowerCase().includes(searchTerm.toLowerCase()) ||
            company.lName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            company.aDate.toLowerCase().includes(searchTerm.toLowerCase()) ||
            company.aInTime.toLowerCase().includes(searchTerm.toLowerCase()) ||
            company.aOutTime.toLowerCase().includes(searchTerm.toLowerCase()) ||
            company.aInTimeRemark.toLowerCase().includes(searchTerm.toLowerCase()) ||
            company.aDefaultBreak.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
        .slice(indexOfFirstCompany, indexOfLastCompany);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const formatDate = (timestamp) => {
        const formattedDate = moment(timestamp).format('YYYY-MM-DD'); // Adjust date format based on the API response
        return formattedDate;
    };

    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <Card>
                <Stack spacing={4} direction="row" align="center">

                    <Button variant="brand" size="sm">
                        <NavLink to='attendance-add' fontSize="sm">Add Attendance</NavLink>
                    </Button>

                </Stack>
                {/* Main Fields */}
                <Table variant="striped" colorScheme="brand">
                    <TableCaption>Attendance. Note*- It Fetch Only This Month's Attendance</TableCaption>
                    <Thead>
                        <Tr>
                            <Th>SR</Th>
                            <Th>NAME</Th>
                            <Th>LOCATION</Th>
                            <Th>DATE</Th>
                            <Th>IN-TIME</Th>
                            <Th>OUT-TIME</Th>
                            <Th>Note</Th>
                            <Th>Status</Th>
                            <Th>Action</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {currentCompanies.map((company, index) => (
                            <Tr key={company.id}>

                                <Td>{indexOfFirstCompany + index + 1}</Td>
                                <Td>{`${company.eFname} ${company.eLname}`}</Td>
                                <Td>{company.lName}</Td>
                                <Td>{formatDate(company.aDate)}</Td>
                                <Td>{company.aInTime}</Td>
                                <Td>{company.aOutTime}</Td>
                                <Td>{company.aInTimeRemark}</Td>
                                <Td>

                                    {company.aStatus === 1 ? (
                                        <Badge variant="solid" colorScheme="green">Present</Badge>
                                    ) : (
                                        <Badge variant="solid" colorScheme="red">Absent</Badge>
                                    )}</Td>
                                <Td>

                                    <Menu>
                                        <MenuButton as={Button} rightIcon={<MdArrowDropDown />}>
                                            Actions
                                        </MenuButton>
                                        <MenuList>
                                        <NavLink to={`attendance-edit/${company.id}`}><MenuItem>Edit</MenuItem></NavLink>
                                            <MenuItem onClick={() => handleStatusChange(company.id, company.aStatus === 1 ? 2 : 1)}> {company.aStatus === 1 ? 'Mark Absent' : 'Mark Present'}</MenuItem>
                                            <MenuItem onClick={() => handleDelete(company.id)}>Delete</MenuItem>

                                        </MenuList>
                                    </Menu>


                                </Td>
                            </Tr>
                        ))}

                    </Tbody>

                </Table>

            </Card>
        </Box>
    );
}
